import { supabase } from '@/lib/supabase';

export interface Seller {
  id: number;
  name: string;
  link: string;
  image: string | null;
  hide: boolean;
  created_at: string;
}

export interface SellerInput {
  name: string;
  link: string;
  image: string | null;
  hide: boolean;
}

const TABLE = 'sellers';

/** Get all sellers for the admin panel (includes hidden ones). */
export const getSellers = async (): Promise<Seller[]> => {
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .order('id', { ascending: true });

  if (error) throw error;
  return (data || []) as Seller[];
};

/** Get only visible sellers (hide = false) — matches what the public site shows. */
export const getVisibleSellers = async (): Promise<Seller[]> => {
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .eq('hide', false)
    .order('id', { ascending: true });

  if (error) throw error;
  return (data || []) as Seller[];
};

export const createSeller = async (input: SellerInput): Promise<Seller> => {
  const { data, error } = await supabase
    .from(TABLE)
    .insert(input)
    .select()
    .single();

  if (error) throw new Error(error.message || 'Failed to create seller');
  return data as Seller;
};

export const updateSeller = async (
  id: number,
  input: Partial<SellerInput>
): Promise<Seller> => {
  const { data, error } = await supabase
    .from(TABLE)
    .update(input)
    .eq('id', id)
    .select()
    .single();

  if (error) throw new Error(error.message || 'Failed to update seller');
  return data as Seller;
};

export const deleteSeller = async (id: number): Promise<void> => {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);
  if (error) throw new Error(error.message || 'Failed to delete seller');
};
